import { NgOptimizedImage } from '@angular/common';
import { Component, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faBars, faSearch } from '@fortawesome/free-solid-svg-icons';
import { select, Store } from '@ngxs/store';
import { HelpUrls } from '../../../../../common/dto/help-urls';
import { AppState, ChangeNavOpenedAction } from '../../app.state';
import { LanguageSelectorComponent } from '../../common/components/language-selector/language-selector.component';
import { RouteNavigationService } from '../../common/services/route-navigation.service';
import { ArticleSearchBarComponent } from './article-search-bar/article-search-bar.component';
import { SearchDialogComponent } from './search-dialog/search-dialog.component';

@Component({
  selector: 'app-header',
  imports: [
    NgOptimizedImage,
    MatButtonModule,
    FaIconComponent,
    MatInputModule,
    ArticleSearchBarComponent,
    RouterLink,
    LanguageSelectorComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  constructor(
    private _store: Store,
    protected routeNavigationService: RouteNavigationService,
    private _dialogService: MatDialog,
  ) {
  }

  protected appState = select(AppState.get);

  protected openNav() {
    this._store.dispatch(new ChangeNavOpenedAction(true));
  }

  protected openSearch() {
    this._dialogService.open(SearchDialogComponent);
  }

  protected readonly faBars = faBars;
  protected readonly HelpUrls = HelpUrls;
  protected readonly faSearch = faSearch;
}
